import React from 'react'
import { Flex, FlexProps } from 'rebass/styled-components'

export interface ActionsProps extends FlexProps {
  items: React.ReactNode[]
}

export const Actions = ({ items, sx, ...props }: ActionsProps): JSX.Element => (
  <Flex data-name="Actions" sx={{ alignItems: 'center', gap: '8px', ...sx }} {...props}>
    {items.map((item, index) => (
      <React.Fragment key={index}>{item}</React.Fragment>
    ))}
  </Flex>
)
